export const backendServer = {
   backendApi: "https://sheltered-shore-33155.herokuapp.com",

   //dev api
   // backendApi: "http://localhost:5000",
};
